import { Column } from '@orion-platform/datagrid';
/**
 * Creates a comparator for array that orders columns
 * according to the given `order` of field names (case-insensitive).
 * @param order - Desired order of field names.
 * @returns Comparator for sort().
 */
export const compareByFieldOrder = (
  order: string[],
): ((a: Column & { index: number }, b: Column & { index: number }) => number) => {
  const rank: Map<string, number> = new Map(
    order.map((name, i): [string, number] => [name.toLowerCase(), i]),
  );

  return (a: Column & { index: number }, b: Column & { index: number }): number => {
    const ra: number | undefined = rank.get(a.field.toLowerCase());
    const rb: number | undefined = rank.get(b.field.toLowerCase());

    const aRanked: boolean = ra !== undefined;
    const bRanked: boolean = rb !== undefined;

    if (aRanked && bRanked) {
      return (ra as number) - (rb as number);
    }

    if (aRanked) return -1;
    if (bRanked) return 1;

    // `??`, not a truthiness check: index 0 is a real position, and treating it
    // as absent sent the first column to the end of everything unranked.
    const ai: number = a.index ?? Number.MAX_SAFE_INTEGER;
    const bi: number = b.index ?? Number.MAX_SAFE_INTEGER;
    if (ai !== bi) return ai - bi;

    return a.field.localeCompare(b.field, undefined, { sensitivity: 'accent' });
  };
};
